module.exports = __webpack_public_path__ + "img/1.4.0ac25a0b.png";